import { axiosServiceNowApi } from 'services/Api'
import { Sector } from 'types/sector'
import { ROUTES_NAMES } from 'constants/servicenow.routes'

const SectionService = {
    createNewSector: (newSector:Sector) => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.sector.post.create, newSector)
    },
    updateSectorBySysId: (sector:Sector, sys_id:string) => {
        return axiosServiceNowApi?.put(ROUTES_NAMES.sector.put.update(sys_id), sector)
    },
    updateSectorWithNotifications: (sector:Sector, sys_id:string, transferData?: any, locationId?: string) => {
        const payload = {
            ...sector,
            transferData
        }
        return axiosServiceNowApi?.put(ROUTES_NAMES.sector.put.update_all_notification_and_sectors(sys_id, locationId), payload)
    },
    getAllSectorsByDestinationSector: (destinationSectorId: string) => {
        return axiosServiceNowApi?.get(ROUTES_NAMES.sector.get.get_all_by_destination_sector(destinationSectorId))
    },
    countNotificationsBySector: (sectorId: string) => {
        return axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.count_by_sector(sectorId))
    }
}

export default SectionService